export enum RolesLoadingEnum {
    Loading,
    Pagination,
    type,
    Filtering,
    Refreshing,
    Creating,
    Deleting,
    Editing
}